// extracted by mini-css-extract-plugin
export var numpadContainer = "_kc-1";
export var phoneButton = "_kc-0";